import { render, staticRenderFns } from "./SidebarApp.vue?vue&type=template&id=16dfc185&scoped=true&"
import script from "./SidebarApp.vue?vue&type=script&lang=js&"
export * from "./SidebarApp.vue?vue&type=script&lang=js&"
import style0 from "./SidebarApp.vue?vue&type=style&index=0&id=16dfc185&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dfc185",
  null
  
)

export default component.exports